"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceInfo = exports.discountInfo = exports.formatPrice = void 0;
var formatPrice = function (price) {
    return (typeof price === 'number' ? price : price.inCents / 100).toFixed(2);
};
exports.formatPrice = formatPrice;
var discountInfo = function (_a) {
    var rentalPlanPrice = _a.rentalPlanPrice, oldPrice = _a.oldPrice;
    var originalPrice = oldPrice || rentalPlanPrice;
    var discountAmount = (0, exports.formatPrice)(originalPrice - rentalPlanPrice);
    var discountPercentage = Math.round(((originalPrice - rentalPlanPrice) / originalPrice) * 100);
    var discountIntervalFallback = "".concat(Math.floor(discountPercentage / 10) * 10, "-").concat(Math.ceil(discountPercentage / 10) * 10);
    var discountInterval = originalPrice === rentalPlanPrice ? '0-10' : discountIntervalFallback;
    return {
        discountAmount: discountAmount,
        discountPercentage: discountPercentage,
        discountInterval: discountInterval,
    };
};
exports.discountInfo = discountInfo;
var getPriceInfo = function (rentalPlan) {
    if (!rentalPlan) {
        return {
            discountAmount: null,
            discountPercentage: null,
            discountInterval: null,
            non_discountedPrice: null,
            price: null,
        };
    }
    var oldPrice = rentalPlan.oldPrice, price = rentalPlan.price;
    return __assign(__assign({}, (0, exports.discountInfo)({
        rentalPlanPrice: price,
        oldPrice: oldPrice,
    })), { non_discountedPrice: (0, exports.formatPrice)(oldPrice || price), price: (0, exports.formatPrice)(price).toString() });
};
exports.getPriceInfo = getPriceInfo;
//# sourceMappingURL=productUtils.js.map